import { MatDialogConfig } from '@angular/material/dialog';

export const getDialogConfig = (config: MatDialogConfig) => {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = false;
  dialogConfig.panelClass = ['primary-dialog'];
  dialogConfig.width = config?.width;
  dialogConfig.data = config?.data;
  return dialogConfig;
};
